export const caseStudySpanishDetails: Record<
  string,
  {
    challenge: string;
    solution: string;
    impact: string[];
  }
> = {
  "deeptrait-ngs-data-analysis": {
    challenge:
      "El análisis de datos de secuenciación de nueva generación (NGS) requería perfiles de bioinformática con habilidades avanzadas de programación. Los equipos de laboratorio tenían que esperar días para obtener resultados y no podían explorar de forma autónoma datasets genómicos, ejecutar pruebas estadísticas ni anotar variantes, lo que generaba cuellos de botella críticos en los flujos preclínicos de descubrimiento de fármacos.",
    solution:
      "Diseñamos y desarrollamos DeepTrait, una plataforma no-code de análisis NGS creada por y para científicos de laboratorio. La solución incorpora pruebas de Kolmogorov-Smirnov, análisis ROC, anotación fluida de variantes y genes en las principales bases de datos y descubrimiento de dianas terapéuticas y biomarcadores con sustento genético. El proceso completo pasa de dato bruto a insight accionable en menos de seis horas.",
    impact: [
      "Reducción del tiempo de análisis NGS de días a menos de 6 horas",
      "Eliminación de la dependencia de bioinformáticos para análisis rutinarios",
      "Aceleración del descubrimiento de nuevas dianas terapéuticas y biomarcadores",
      "Cobertura de las principales bases de datos de anotación de variantes y genes",
    ],
  },
  "astrazeneca-medical-affairs-ai": {
    challenge:
      "AstraZeneca necesitaba aumentar la eficiencia analítica de Medical Affairs y extraer insights de mayor valor del gran volumen de datos CRM generado por sus Medical Science Liaisons. El enfoque manual era lento y no conseguía detectar patrones accionables de forma consistente.",
    solution:
      "Desarrollamos un producto de IA que automatiza el análisis de registros CRM, crea una visión consolidada de la operación y genera insights accionables a escala. La solución incluyó una pipeline de insights que aporta valor tanto a equipos de campo como a HQ.",
    impact: [
      "Aceleración de la toma de decisiones basada en datos con más precisión",
      "Mejora simultánea de la efectividad comercial y operativa",
      "Conversión de datos CRM complejos en un activo estratégico",
      "Simplificación de flujos de trabajo y nuevas formas de explotar insights",
    ],
  },
  "civitta-ai-accelerator-consulting": {
    challenge:
      "Civitta, firma internacional de consultoría, necesitaba dotar a las startups de su Challenger AI Accelerator de estrategias sólidas de producto IA y hojas de ruta claras de implementación para construir ventajas competitivas sostenibles en el ecosistema de IA generativa.",
    solution:
      "Diseñamos estrategias de producto IA completas y planes de implementación accionables para cuatro startups en tres países (Ucrania, Estonia y Brasil). El trabajo incluyó arquitecturas de sistema detalladas para despliegues de IA generativa seguros, escalables y eficientes.",
    impact: [
      "Los cuatro equipos resolvieron sus retos tecnológicos en IA",
      "Entrega de estrategias de producto IA con planes de go-to-market",
      "Blueprints de arquitectura GenAI escalables para cada startup",
      "Hojas de despliegue multi-cloud adaptadas a cada caso",
    ],
  },
  "xfusion-rag-chatbot": {
    challenge:
      "xFusion necesitaba construir su plataforma xAQUA® para que los usuarios pudieran obtener respuestas precisas y contextualizadas en lenguaje natural sobre repositorios documentales empresariales complejos en formatos DOCX, PDF y TXT.",
    solution:
      "Diseñamos e implementamos un sistema de recuperación documental basado en LangChain e integrado con Postgres pgvector. La solución soporta ChatGPT y GPT-4 de OpenAI, además de integración plug-and-play con Llama-2, Mistral y otros LLM de acceso abierto.",
    impact: [
      "Reducción drástica del tiempo para localizar información crítica",
      "Mejora de la calidad de decisión gracias a datos accesibles al instante",
      "Refuerzo de la propuesta competitiva de la plataforma xAQUA®",
      "Entrega en formato Python wheel reutilizable para integración ágil",
    ],
  },
  "periodix-lead-generation-ai": {
    challenge:
      "Periodix quería mejorar de forma significativa su capacidad de generación de leads mediante un asistente comercial con IA, capaz de mantener interacciones personalizadas y de alta efectividad con potenciales clientes.",
    solution:
      "Desarrollamos y entrenamos un modelo conversacional personalizado sobre Llama-2 utilizando diálogos comerciales exitosos, junto con un modelo de despliegue flexible que permite actualizaciones y adaptación continua. La solución se entregó como componente cloud de nivel producto.",
    impact: [
      "Interacción más efectiva y personalizada con leads potenciales",
      "Mejora de la captación de prospectos con alta intención de compra",
      "Actualizaciones y sustitución de modelos de IA sin fricción",
      "Entrega de la nueva funcionalidad dentro del plazo comprometido",
    ],
  },
  "dynamiq-genai-platform-strategy": {
    challenge:
      "Dynamiq, una plataforma líder en IA generativa, necesitaba una estrategia avanzada para reforzar su oferta de producto, profundizar el engagement de usuarios y aumentar la eficiencia operativa en un mercado de IA en rápida evolución.",
    solution:
      "Definimos e implementamos una estrategia integral que incluyó diseño y desarrollo de modelos generativos propios (Llama 3 y Mistral), fine-tuning con datos propietarios de Dynamiq, análisis de mercado, benchmarking competitivo e integración RAG.",
    impact: [
      "Mejora de la oferta de producto con capacidades GenAI de última generación",
      "Mayor engagement y satisfacción mediante respuestas contextuales",
      "Optimización de los procesos de recuperación de información",
      "Incremento global de la eficiencia operativa",
    ],
  },
  "axbio-questionnaire-analysis": {
    challenge:
      "Axbio necesitaba un sistema escalable y automatizado para recopilar cuestionarios de salud, analizar respuestas con un modelo de scoring ponderado y entregar informes personalizados sin exigir perfiles técnicos para administrar o actualizar el contenido de los cuestionarios.",
    solution:
      "Diseñamos y desarrollamos una pipeline cloud-native usando Microsoft Forms para la gestión del cuestionario, Power Automate para el enrutado de respuestas y un microservicio Python en Azure Container Apps para el procesamiento. Azure OpenAI genera informes de salud personalizados a partir del análisis ponderado y Azure Communication Services gestiona el envío por correo. El sistema permite a perfiles no técnicos crear, editar o eliminar preguntas y ajustar pesos de scoring.",
    impact: [
      "Pipeline totalmente automatizada desde envío del cuestionario hasta entrega del informe",
      "Gestión de preguntas y ponderaciones por personal no técnico",
      "Informes de salud personalizados generados por IA para cada usuario",
      "Arquitectura escalable sobre Azure Container Apps",
    ],
  },
  "pumb-retail-banking-ai-strategy": {
    challenge:
      "Un gran banco minorista necesitaba una estrategia de IA integral dentro del diseño de su estrategia de negocio. Requería análisis y recomendaciones de modelos de IA en las dimensiones de impacto, viabilidad, coste y ventaja sostenible.",
    solution:
      "Diseñamos una estrategia completa con análisis competitivo de IA, gap analysis, evaluación de prácticas actuales, valoración de opciones estratégicas mediante pruebas de guerrilla y recomendaciones priorizadas. Además, acompañamos al equipo cliente en el desarrollo de modelos para Marketing y CRM (CLV, segmentación conductual, A/B testing y recomendaciones personalizadas).",
    impact: [
      "La mayoría de recomendaciones se implementaron o iniciaron su ejecución",
      "Formación y dotación del equipo de IA/Data Science según la hoja de ruta",
      "Mejora de conversiones y métricas financieras en crédito",
      "Mejora significativa de métricas en modelos de Marketing y CRM",
      "Lanzamiento de nuevos modelos según la matriz Impacto/Inversión",
    ],
  },
  "bank-rag-chatbot": {
    challenge:
      "El banco necesitaba permitir que empleados y stakeholders encontraran respuestas precisas y contextuales dentro de un gran corpus de documentos internos que cubría múltiples áreas del negocio. La búsqueda manual era lenta y a menudo devolvía resultados incompletos o irrelevantes.",
    solution:
      "Diseñamos y entregamos un sistema RAG completo formado por una librería de Python con componentes DocumentManager y ConversationManager, un microservicio Flask contenerizado con APIs REST y una utilidad de carga de datos para ingerir más de 3.200 documentos. El sistema admite conversaciones multi-turno, procesamiento de documentos con imágenes y varios modos de conversación.",
    impact: [
      "Más de 3.200 documentos ingeridos y consultables mediante búsqueda semántica",
      "Soporte para conversaciones multi-turno con respuestas conscientes del contexto",
      "Análisis de imágenes para gráficos y elementos visuales en documentos",
      "Microservicio contenerizado listo para producción con despliegue en Docker",
    ],
  },
};
